export const getVsInfo = {
  persons: {
    items: [
      {
        id: '614c4017f60ae6bf2379793a1',
        nativeGivenName: 'Jazz',
        nativeFamilyName: 'Gold',
        nationalityCode: 'USA',
        birthYear: 1986,
        age: 36,
        sex: 'M',
        biographicalInformation: null,
        worldTennisNumbers: [
          {
            type: 'SINGLE',
            tennisNumber: 31.3,
            confidence: 80,
            __typename: 'MatchUpWorldTennisNumber',
          },
        ],
        __typename: 'Person',
      },
      {
        id: '1',
        nativeGivenName: 'July',
        nativeFamilyName: 'Prism',
        nationalityCode: 'USA',
        birthYear: 0,
        age: 0,
        sex: 'F',
        biographicalInformation: null,
        worldTennisNumbers: [
          {
            type: 'SINGLE',
            tennisNumber: 34.03,
            confidence: 60,
            __typename: 'MatchUpWorldTennisNumber',
          },
        ],
        __typename: 'Person',
      },
    ],
    totalItems: 2,
    __typename: 'PersonList',
  },
  matchUpStatistics: {
    matchUpVsStatisticsCount: {
      totalMatches: 4,
      wins: 0,
      losses: 4,
      __typename: 'MatchUpWinLossCount',
    },
    winLikelihood: 90,
    __typename: 'MatchUpVsStatistics',
  },
}
